"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Resale = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var Resale = function (props) {
    var sx = props.sx, filledColor = props.filledColor, args = __rest(props, ["sx", "filledColor"]);
    var filledColorSxProps = {
        color: 'common.white',
        p: 1,
        display: 'block',
    };
    return ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: filledColor
            ? {
                width: 'fit-content',
                height: 'fit-content',
                bgcolor: 'primary.main',
                borderRadius: '50%',
            }
            : {}, children: (0, jsx_runtime_1.jsx)(material_1.SvgIcon, __assign({ sx: filledColor ? __assign(__assign({}, filledColorSxProps), sx) : sx }, args, { children: (0, jsx_runtime_1.jsxs)("svg", { width: "23", height: "24", viewBox: "0 0 23 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [(0, jsx_runtime_1.jsx)("path", { d: "M18.4383 14.0519C17.524 11.8107 15.3653 10.3188 12.911 10.3188C12.4985 10.3188 12.1616 10.6557 12.1616 11.0682C12.1616 11.4807 12.4985 11.8176 12.911 11.8176C14.5953 11.8176 16.1078 12.7525 16.8709 14.2031L15.8534 14.3062L18.0396 17.3518L19.5864 13.9419L18.4452 14.0519H18.4383Z", fill: "currentColor" }), (0, jsx_runtime_1.jsx)("path", { d: "M15.1935 18.5962C13.5092 18.5962 11.9967 17.6613 11.2336 16.2107L12.2511 16.1076L10.0649 13.062L8.51806 16.4719L9.65928 16.3619C10.5736 18.6031 12.7323 20.095 15.1866 20.095C15.5991 20.095 15.936 19.7581 15.936 19.3456C15.936 18.9331 15.5991 18.5962 15.1866 18.5962H15.1935Z", fill: "currentColor" }), (0, jsx_runtime_1.jsx)("path", { d: "M16.9396 7.14272L17.2764 4.89464C17.4689 3.83592 16.7952 2.78408 15.7433 2.59158L11.7147 1.8216C11.6666 0.811001 10.821 -0.000226974 9.79662 -0.000226974H1.91808C0.866228 -0.000226974 0 0.866001 0 1.91785V14.7806C0 15.8394 0.866228 16.6987 1.91808 16.6987L5.38986 16.7262C6.07046 20.8442 9.65224 23.9998 13.9559 23.9998C18.7545 23.9998 22.6526 20.1018 22.6526 15.3031C22.6526 11.5563 20.267 8.35956 16.9327 7.14272H16.9396ZM11.7078 3.8153L15.3515 4.50966L15.0559 6.6821C14.6984 6.63398 14.334 6.60648 13.9628 6.60648C13.1172 6.60648 12.2991 6.7371 11.5222 6.96396L11.7078 3.82218V3.8153ZM1.91808 2.88032V1.91785H9.886V7.62396C7.28732 9.0058 5.4861 11.6732 5.29362 14.7669H1.91808V2.87346V2.88032ZM13.9628 22.1848C10.1679 22.1848 7.08106 19.098 7.08106 15.2963C7.08106 11.4945 10.1679 8.41456 13.9628 8.41456C17.7577 8.41456 20.8514 11.5014 20.8514 15.2963C20.8514 19.0912 17.7645 22.1848 13.9628 22.1848Z", fill: "currentColor" })] }) })) }));
};
exports.Resale = Resale;
